import * as React from 'react'

import type { IconProps } from '@/icons/types'
export const CheckCircleMiniSolid = React.forwardRef<SVGSVGElement, IconProps>(
	({ color = 'currentColor', ...props }, ref) => {
		return (
			<svg xmlns='http://www.w3.org/2000/svg' width={15} height={15} fill='none' ref={ref} {...props}>
				<g clipPath='url(#a)'>
					<path
						fill={color}
						d='M7.5.389C3.58.389.389 3.579.389 7.5s3.19 7.111 7.111 7.111 7.111-3.19 7.111-7.111S11.421.389 7.5.389m3.416 5.074-3.778 4.889a.67.67 0 0 1-.502.258h-.025a.67.67 0 0 1-.496-.22l-2-2.222a.668.668 0 0 1 .992-.893l1.465 1.629 3.29-4.257a.667.667 0 0 1 1.055.815z'
					/>
				</g>
				<defs>
					<clipPath id='a'>
						<path fill='#fff' d='M0 0h15v15H0z' />
					</clipPath>
				</defs>
			</svg>
		)
	}
)
CheckCircleMiniSolid.displayName = 'CheckCircleMiniSolid'
